export default [
  {
    type: 'Starter',
    searches: "7 day free trial",
    price: false,
    id: 'starter'
  },
  {
    type: 'One Month',
    searches: 'Unlimited access for one month',
    price: 4.99,
    discount_price: false, // no academic price for a one-off month
    recurrence: false,
    abbreviation: false,
    plan_id: 'monthly_single',
    saving: ''
  },
  {
    type: 'Monthly Premium',
    searches: 'Unlimited access',
    price: 4.99,
    discount_price: 2.0,
    recurrence: 'month',
    abbreviation: 'mo',
    plan_id: 'monthly_premium'
  },
  {
    type: 'Yearly Premium',
    searches: 'Unlimited access',
    price: 49.99,
    discount_price: 20.0,
    recurrence: 'year',
    abbreviation: 'yr',
    plan_id: 'yearly_premium',
    saving: 'Two months free when paying annually'
  }
];
